// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"TagsField-styles_searchInput__38S4U","chipTag":"TagsField-styles_chipTag__5IU_g"};